import React from 'react';
import { motion } from "motion/react";
import { PageTransitions } from "../../../../../utils/transitions";

const TryhardPageFrame: React.FC<any> = ({ children }) => {
    return (
        <motion.div
            variants={PageTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='w-full flex flex-col grow py-6 justify-center items-center relative'
            style={{ backgroundImage: 'url("/thg/bg/bg_landing.png")' }}
        >
            {children}
        </motion.div>
    )
}

export default TryhardPageFrame;